export default __webpack_public_path__ + "static/media/HW_6.9b76a7b8.png";